(function () {
  const overlay = document.getElementById("wholesale-popup-overlay");
  if (!overlay) return;

  const closeBtn = overlay.querySelector(".wholesale-popup-close");
  const ctaBtn = overlay.querySelector(".wholesale-popup-cta");
  const formWrap = overlay.querySelector(".wholesale-popup-form");
  const closeLink = overlay.querySelector("[data-wholesale-close]");

  if (!closeBtn || !ctaBtn || !formWrap) return;

  /* -------------------------
     ANALYTICS HELPER
  -------------------------- */
  function trackEvent(eventName, params) {
    if (typeof window.gtag === "function") {
      window.gtag(
        "event",
        eventName,
        Object.assign(
          {
            event_category: "Wholesale Popup",
            event_label: "Solinco B2B",
          },
          params || {}
        )
      );
    }
  }

  /* -------------------------
     PAGE CHECK (ALL PAGES EXCEPT EXCLUDED)
  -------------------------- */
  const path = window.location.pathname || "";

  const isExcluded =
    path.includes("/checkout") ||
    path.includes("/cart") ||
    path.includes("/account") ||
    document.body.classList.contains("template-cart") ||
    document.body.classList.contains("template-customers-login") ||
    document.body.classList.contains("template-customers-account");

  if (isExcluded) return;

  // Optional: do not show to logged-in SparkLayer wholesale users
  if (window.sparkOptions && window.sparkOptions.auth && window.sparkOptions.auth.user) return;

  /* -------------------------
     STORAGE / TIMING SETTINGS
  -------------------------- */
  const STORAGE_KEY = "wholesale_popup_hide_until";
  const HIDE_DAYS = 5;
  const SCROLL_TRIGGER_PX = 220;
  const AUTO_OPEN_MS = 2000; // show within first 2 seconds

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // do nothing
    }
  }

  const now = Date.now();
  const hideUntil = Number(safeGet(STORAGE_KEY) || "0");
  if (hideUntil && now < hideUntil) return;

  /* -------------------------
     CTA LABELS (ALL CAPS)
  -------------------------- */
  const CTA_CLOSED_LABEL = "APPLY FOR A WHOLESALE ACCOUNT";
  const CTA_OPEN_LABEL = "HIDE WHOLESALE FORM";

  /* -------------------------
     SCROLL LOCK
  -------------------------- */
  function lockScroll() {
    document.documentElement.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.documentElement.style.overflow = "";
  }

  /* -------------------------
     OPEN / CLOSE POPUP
  -------------------------- */
  function openPopup() {
    overlay.classList.add("is-active");
    overlay.setAttribute("aria-hidden", "false");
    lockScroll();

    // Always reset dropdown state
    formWrap.classList.add("is-hidden");
    formWrap.setAttribute("aria-hidden", "true");
    ctaBtn.setAttribute("aria-expanded", "false");
    ctaBtn.textContent = CTA_CLOSED_LABEL;

    trackEvent("wholesale_popup_view");
  }

  function closePopup(daysToHide, reason) {
    overlay.classList.remove("is-active");
    overlay.setAttribute("aria-hidden", "true");
    unlockScroll();

    const ms = (daysToHide || HIDE_DAYS) * 24 * 60 * 60 * 1000;
    safeSet(STORAGE_KEY, String(Date.now() + ms));

    trackEvent("wholesale_popup_close", { reason: reason || "unknown" });
  }

  /* -------------------------
     CLOSE ACTIONS
  -------------------------- */
  closeBtn.addEventListener("click", () => closePopup(HIDE_DAYS, "close_button"));

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closePopup(HIDE_DAYS, "overlay_click");
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-active")) {
      closePopup(HIDE_DAYS, "escape_key");
    }
  });

  if (closeLink) {
    closeLink.addEventListener("click", () => closePopup(HIDE_DAYS, "continue_shopping"));
  }

  /* -------------------------
     DROPDOWN TOGGLE
  -------------------------- */
  ctaBtn.addEventListener("click", () => {
    const isHidden = formWrap.classList.contains("is-hidden");

    // Track the click itself
    trackEvent("wholesale_popup_cta_click", { state: isHidden ? "opening" : "closing" });

    if (isHidden) {
      formWrap.classList.remove("is-hidden");
      formWrap.setAttribute("aria-hidden", "false");
      ctaBtn.setAttribute("aria-expanded", "true");
      ctaBtn.textContent = CTA_OPEN_LABEL;

      trackEvent("wholesale_popup_form_open");
    } else {
      formWrap.classList.add("is-hidden");
      formWrap.setAttribute("aria-hidden", "true");
      ctaBtn.setAttribute("aria-expanded", "false");
      ctaBtn.textContent = CTA_CLOSED_LABEL;

      trackEvent("wholesale_popup_form_close");
    }
  });

  /* -------------------------
     TRIGGERS (AUTO + SCROLL)
  -------------------------- */
  let opened = false;

  function onScrollTrigger() {
    if (opened) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > SCROLL_TRIGGER_PX) {
      opened = true;
      window.removeEventListener("scroll", onScrollTrigger);
      openPopup();
    }
  }

  // Auto-open after 2 seconds
  setTimeout(function () {
    if (opened) return;
    opened = true;
    window.removeEventListener("scroll", onScrollTrigger);
    openPopup();
  }, AUTO_OPEN_MS);

  window.addEventListener("scroll", onScrollTrigger, { passive: true });
})();